// The frame of the signature screens: the pane header with its breadcrumb and the page padding.
// Every member may open them (the lists only hold the requests that concern the caller), so there is
// no permission gate here; the actions inside check what the API says the caller may do.
import { MainPane, PaneHeader, layout, type BreadcrumbEntry } from '@batiflow/ui';
import { __css } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = __css({"content":{"B7ck84d":"f1ewtqcl","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1k5ttpu","rjzwhg":"fwktzdr","Dbcxam":"f124qyjj","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1xzk6ru","Bfkbjar":"f10mjh0z","Bhzhn95":0,"B0czu1p":0,"cglito":"f10fimcf"}});

export interface SignaturesFrameProps {
  /** The title of the pane (default: the section's name). */
  title?: string;
  breadcrumb?: readonly BreadcrumbEntry[];
  actions?: ReactNode;
  children: ReactNode;
}

export function SignaturesFrame({ title, breadcrumb, actions, children }: SignaturesFrameProps) {
  const { t } = useTranslation('signatures');
  const styles = useStyles();
  return (
    <MainPane
      header={
        <PaneHeader
          title={title ?? t('title')}
          {...(breadcrumb ? { breadcrumb } : {})}
          {...(actions ? { actions } : {})}
        />
      }
    >
      <div className={styles.content}>{children}</div>
    </MainPane>
  );
}


import "/opt/batiflow/app/apps/web/src/features/signatures/signatures-frame.griffel.css";